// extracted by mini-css-extract-plugin
module.exports = {"info":"styles_info__2npUt","btns":"styles_btns__2fniM"};